import { useQuery } from '@tanstack/react-query';
// Service
import { getUsers } from './usersService';

/**
 * @description Get the list of admin users.
 * @param {object} queryParams
 * @param {string} [queryParams.sort]
 * @param {string} [queryParams.order]
 * @param {number} [queryParams.pageNumber]
 * @param {number} [queryParams.pageSize]
 * @param {string} [queryParams.search]
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {total: number, page: number, data: User[]}, Error>}
 */
export const useGetAdminListQuery = (queryParams, options) => useQuery({
  queryKey: ['admin-users', queryParams],
  queryFn: () => getUsers(queryParams),
  ...options,
});
